import { Icon, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import SimpleDialogContentCarded from './SimpleDialogContentCarded';

const DefaultHeaderComponent = ({ title, icon, toolbar, subtitle }) => {
  return (
    <div className="flex flex-1 w-full items-center justify-between">
      <div className="flex">
        {icon && <Icon className="text-32">{icon}</Icon>}
        <div className="flex flex-col">
          <Typography className="hidden sm:flex mx-0 sm:mx-12" variant="h6">
            {title}
          </Typography>
          {subtitle && (
            <Typography className="hidden sm:flex mx-0 ml-36" variant="h9">
              {subtitle}
            </Typography>
          )}
        </div>
      </div>
      <div className="flex">{toolbar}</div>
    </div>
  );
};

function FormDialogContent({ header, contentToolbar, content, innerScroll, fullScreen, contentStyle, onSubmit }) {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onSubmit(event);
      }}
      noValidate
      autoComplete="off"
      className="flex container w-full h-full"
    >
      <SimpleDialogContentCarded
        innerScroll={innerScroll}
        fullScreen={fullScreen}
        header={
          <DefaultHeaderComponent
            title={header.title}
            icon={header.icon}
            toolbar={header.toolbar}
            subtitle={header.subtitle}
          />
        }
        contentToolbar={contentToolbar}
        content={<div style={{ padding: '16px', ...contentStyle }}>{content}</div>}
      />
    </form>
  );
}

FormDialogContent.propTypes = {
  header: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape({
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      toolbar: PropTypes.node,
    }),
  ]),
  contentToolbar: PropTypes.node,
  content: PropTypes.node,
  innerScroll: PropTypes.bool,
  contentStyle: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
};

FormDialogContent.defaultProps = {
  innerScroll: true,
  contentStyle: {},
};

export default FormDialogContent;
